import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import {
	Modal
} from 'ant-design-vue'
Vue.use(Antd)

//引入iconfont
import '@/assets/iconfont/iconfont.css'

Vue.config.productionTip = false

//引入全局路由
import navigation from './assets/js/navigation.js'
Vue.prototype.navigation = navigation

//引入图表插件
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

//引入公共方法库
import qaUtil from './assets/js/qaUtil.js'
Vue.prototype.qaUtil = qaUtil

import axios from 'axios'

// 创建一个 axios 实例
const http = axios.create({
	baseURL: navigation.url, // 根据你的实际 baseURL 设置
	withCredentials: true,
});

// 请求拦截器：自动携带 token
http.interceptors.request.use(config => {
	config.headers.userToken = window.sessionStorage.getItem('token') || '';
	// 如果有某些请求不需要携带 token（比如登录请求），可以通过自定义属性标记
	if (config.ignoreAuth) {
		console.log("请求拦截器，忽略校验token")
		delete config.headers.userToken;
		console.log(config)
	}
	return config;
}, error => Promise.reject(error));

// -----------------------------------
// 关键点：响应拦截器 + 请求队列化
// -----------------------------------

// 用来保存所有“待处理”的请求
let requestQueue = [];

// 标记当前是否正在进行 token 校验请求
let isChecking = false;

// 响应拦截器
http.interceptors.response.use(
	response => {
		// 正常响应
		if (response.data && response.data.code === 1000) {
			// 1. 将当前请求包装成一个函数，放入队列
			const originalRequest = response.config;

			// 2. 如果当前已经有请求在检查 token，就不重复发起
			if (isChecking) {
				return new Promise(resolve => {
					requestQueue.push(() => {
						// 重新发送原始请求
						resolve(http(originalRequest));
					});
				});
			}

			// 3. 只有第一个请求进入校验逻辑
			isChecking = true;

			// 4. 将当前请求加入队列
			return new Promise(resolve => {
				requestQueue.push(() => {
					// 重新发送原始请求
					resolve(http(originalRequest));
				});

				Modal.warning({
					title: '系统提示',
					content: response.data.msg,
					onOk() {
						requestQueue = [];
						isChecking = false;
						// 2. 跳转登录页
						router.push('/Login');
					},
				});
			});
		} else {
			// 处理其他业务码
			return response;
		}
	},
	async error => {
		console.log(error)
		const {
			response
		} = error;
		// 如果是网络错误或未响应，直接 reject
		if (!response) {
			return Promise.reject(error);
		}
		// 处理其他错误
		return Promise.reject(error);
	},
);

Vue.prototype.$http = http


new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')